import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useHighlight } from 'modules/highlight/hooks'
import { Button, Col, Container, Row } from 'react-bootstrap'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import ThumbDownIcon from '@mui/icons-material/ThumbDown'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import PinterestIcon from '@mui/icons-material/Pinterest'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { HlsVideoPlayer } from '../../modules/core/components'

import { EventCss } from './EventCss'
import './event.css'

export const Highlight = () => {
  const { uuid } = useParams()
  const { highlight } = useHighlight(uuid)

  useEffect(() => {
    if (!highlight) return

    document.title = `${highlight.name} | Staidium`
  }, [highlight])

  // @ts-ignore
  const highlightStream = highlight?.mediaAssetLocators.find(({ url }) => url)

  const srcType =
    highlightStream && highlightStream?.url.endsWith('.mp4')
      ? 'video/mp4'
      : 'application/x-mpegURL'

  return (
    <div style={{ background: '#000' }} className='showEvent'>
      <Breadcrumb
        title={''}
        competition={highlight?.event?.competition.name}
        sport={highlight?.event?.sport?.name}
        date={highlight?.event?.startTime}
      />
      <Container style={{ padding: '50px 70px' }} className='event-container'>
        <div className='video-wrap' style={{ width: '100%' }}>
          <HlsVideoPlayer src={highlightStream?.url} type={srcType} />
        </div>

        <div
          className='event-details-content'
          style={{ margin: '25px 0 25px' }}>
          <Container>
            <Row>
              <Col md={12} className='event-details-info'>
                <ul
                  style={{
                    listStyle: 'outside none none',
                    margin: 0,
                    padding: 0
                  }}>
                  <li style={EventCss.eventDetailItem}>
                    <span style={EventCss.eventDetailTitle}>
                      {highlight?.name}
                    </span>
                  </li>
                  <li style={EventCss.eventDetailItem}>
                    <span style={EventCss.eventDetailTitle}>Venue: </span>{' '}
                    {highlight?.event?.competition.name}
                  </li>
                  <li style={EventCss.eventDetailItem}>
                    {/* <span style={EventCss.eventDetailTitle}>Venue: </span> {event.venue} */}
                  </li>
                </ul>
              </Col>

              <Col
                md={12}
                className='like-share-wrap'
                style={EventCss.eventSharePanel}>
                <div className='social-share-wrap' style={{ display: 'flex' }}>
                  <span style={EventCss.eventDetailTitle}>Share:</span>
                  <div className='social-style-1'>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: '#3b5998'
                      }}
                      className='facebook'
                      to='#'>
                      <FacebookIcon></FacebookIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: '#bd081c'
                      }}
                      className='pinterest'
                      to='#'>
                      <PinterestIcon></PinterestIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: '#0A66C2'
                      }}
                      className='linkedin'
                      to='#'>
                      <LinkedInIcon></LinkedInIcon>
                    </Link>
                    <Link
                      style={{
                        ...EventCss.shareIcon,
                        backgroundColor: '#E4405F'
                      }}
                      className='instagram'
                      to='#'>
                      <InstagramIcon></InstagramIcon>
                    </Link>
                  </div>
                </div>
                <div className='like-dislike-wrap'>
                  <Button
                    className='like-dislike-style'
                    style={EventCss.likeDislikeButton}>
                    <ThumbUpIcon />
                  </Button>
                  <Button
                    className='like-dislike-style'
                    style={EventCss.likeDislikeButton}>
                    <ThumbDownIcon />
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </div>
  )
}
